export class TrackingEvent {
	constructor(categories, actions, labels, values) {
		if (typeof categories != 'string') {
			throw new TypeError("Error creating TrackingEvent. Required parameter categories must be a string. ('" + categories + "')");
		}
		if (typeof actions != 'string') {
			throw new TypeError("Error creating TrackingEvent. Required parameter actions must be a string. ('" + actions + "')");
		}
		if (labels !== undefined && typeof labels != 'string') {
			throw new TypeError("Error creating TrackingEvent. Optional parameter labels must be a string. ('" + labels + "')");
		}
		if (values !== undefined && isNaN(values)) {
			throw new TypeError("Error creating TrackingEvent. Optional parameter values must be an int. ('" + values + "')");
		}

		this.categories = categories;
		this.actions = actions;
		this.labels = labels;
		this.values = values;
	}
}